<template>
  <div class="h-100 d-flex justify-center align-center">
    <template v-if="stripeInfo">
      <AppCard class="w-50">
        <v-row>
          <v-col class="text-center">
            <h1>{{ $t('payment.Payment.title') }}</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <font-awesome-icon 
              :icon="['far', 'file-invoice']"
              style="font-size: 100px;"
            ></font-awesome-icon>
          </v-col>
        </v-row>
        <v-row class="text-body-1">
          <v-col>
            <v-row>
              <v-col>
                <h2>{{ $t('payment.Payment.details') }}</h2>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('payment.Payment.extRef') }}
                {{ stripeInfo.invoice.ref }}
              </v-col>
              <v-col>
                {{ $t('payment.Payment.subscriptionName') }}
                {{ stripeInfo.invoice.subscriptionName }}
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('payment.Payment.period') }}
                <DateDisplay :value="stripeInfo.invoice.fromDate"/>
                -
                <DateDisplay :value="stripeInfo.invoice.toDate"/>
              </v-col>
              <v-col>
                {{ $t('payment.Payment.dueDate') }}
                <DateDisplay :value="stripeInfo.invoice.dueDate"/>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                {{ $t('payment.Payment.date') }}
                <DateDisplay :value="stripeInfo.invoice.invoiceDate"/>
              </v-col>
              <v-col>
                {{ $t('payment.Payment.amountGross') }}
                {{ $t('payment.Payment.amount', { amount: stripeInfo.invoice.amountGross }) }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center">
            <AppButton
              color="primary"
              @click="redirectToCheckout"
            >
              {{ $t('payment.Payment.pay') }}
            </AppButton>
          </v-col>
        </v-row>
      </AppCard>
    </template>
  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js'
import { mapActions, mapState } from 'vuex'

import AppCard from '@/common/AppCard.vue'
import AppButton from '@/common/buttons/AppButton.vue'
import DateDisplay from '@/common/DateDisplay.vue'
import { GET_STRIPE_INFO } from '@/store/modules/payment/action_types'

export default {
  name: 'Payment',
  components: {
    DateDisplay,
    AppCard,
    AppButton,
  },
  props: {
    token: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('payment', ['stripeInfo']),
  },
  created () {
    this.prepareGetStripeInfo()
  },
  methods: {
    ...mapActions('payment', [GET_STRIPE_INFO]),
    async prepareGetStripeInfo () {
      try {
        await this.GET_STRIPE_INFO(this.token)
      } catch (error) {
        console.error(error.response)
      }
    },
    async redirectToCheckout () {
      try {
        const stripe = await loadStripe(import.meta.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
        stripe.redirectToCheckout({ sessionId: this.stripeInfo.session })
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>
